<template>
  <div>
    <!-- banner -->
    <div class="archive-banner banner">
      <h1 class="banner-title">归档</h1>
    </div>
    <!-- 归档列表 -->
    <v-card class="blog-container">
      <timeline>
        <timeline-title style="color: #858585"> 目前共计{{ total }}篇文章，继续加油 </timeline-title>
        <timeline-item v-for="item of archiveList" :key="item.articleId">
          <!-- 日期 -->
          <span class="time">{{ item.createTime | date }}</span>
          <!-- 文章标题 -->
          <router-link class="article-title" :to="'/articles/' + item.articleId" >{{ item.articleTitle }}</router-link>
        </timeline-item>
      </timeline>
      <!-- 分页按钮 -->
      <v-pagination color="#00C4B6" v-model="current" :length="Math.ceil(total / 10)" total-visible="7"/>
    </v-card>
  </div>
</template>

<script>
import { Timeline, TimelineItem, TimelineTitle } from "vue-cute-timeline";
import { getArchiveArticles } from "@/api/article";
export default {
  created() {
    this.listArchives();
  },
  components: {
    Timeline,
    TimelineItem,
    TimelineTitle
  },
  data: function() {
    return {
      current: 1,
      total: 0,
      archiveList: []
    };
  },
  methods: {
    listArchives() {
      const params = { current: this.current };
      getArchiveArticles(params).then(res => {
        this.archiveList = res.rows;
        this.total = res.total;
      });
    }
  },
  watch: {
    current(value) {
      const params = { current: value };
      getArchiveArticles(params).then(res => {
        this.archiveList = res.rows;
        this.total = res.total;
      });
    }
  }
};
</script>

<style scoped>
.archive-banner {
  background: #49b1f5 url(../../assets/img/archives.jpg) no-repeat center center;
}
.time {
  font-size: 0.75rem;
  color: #858585;
  margin-right: 1rem;
}
.theme--dark .timeline-title{
  color: #fff;
}
</style>
